import { Component, ElementRef, Renderer2 } from '@angular/core';
import {ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MatSelect } from '@angular/material/select';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { CustomerService } from 'src/app/shared/services/customer.service';
import { DriverService } from 'src/app/shared/services/driver.service';
import { FactoryService } from 'src/app/shared/services/factory.service';
import { LoadingOrderService } from 'src/app/shared/services/loading-order.service';
import { ProductsService } from 'src/app/shared/services/products.service';
import { TransporterService } from 'src/app/shared/services/transporter.service';
import { VehicleService } from 'src/app/shared/services/vehicle.service';
import { ILoadingOrder } from 'src/core/interfaces/loading-order';
import { Location } from '@angular/common';
import Swal from "sweetalert2";
import { UserService } from 'src/app/shared/services/user.service';
import jsPDF from 'jspdf';
import html2pdf from 'html2pdf.js';
import { TransactionsInternalServicesService } from 'src/app/shared/services/transactions-internal-services.service';
import { LoadingOrderPdfComponent } from 'src/app/shared/modules/print-templates/loading-order-pdf/loading-order-pdf.component';

@Component({
  selector: 'app-view-loading-order',
  templateUrl: './view-loading-order.component.html',
  styleUrl: './view-loading-order.component.scss'
})
export class ViewLoadingOrderComponent {
  loadingOrderForm: FormGroup;
  loadingOrderId: number;
  filteredCustomers :any; // Add logic to fetch customer data
  filteredProducts :any; // Add logic to fetch product data
  filteredfactories: any;
  transporters = []; // Add logic to fetch transporter data
  factories: any[];
  vehicles = []; // Add logic to fetch vehicle data
  LoadingOrders: ILoadingOrder[];
  products: any[];
  customers: any[];
  drivers: any;
  locations: string[];
  customerLocations: any;
  @ViewChild('customerSelect') customerSelect: MatSelect;
  @ViewChild('productSelect') productSelect: MatSelect;
  @ViewChild('factorySelect') factorySelect: MatSelect;
  @ViewChild('hiddenReport', { static: false }) hiddenReport: LoadingOrderPdfComponent | undefined;

  // Reference to the element to render the report off-screen
  //@ViewChild('hiddenReport', { static: false }) hiddenReport: ElementRef;

 
  customer: any;
  LoadingOrderStatus: any;
  data: any;
  customerName: any;
  orderNumber: any;
  latitude:any;
  longitude:any;


  constructor(
    private fb: FormBuilder,
    private route: ActivatedRoute,
    private translateService: TranslateService,
    private loadingOrderService: LoadingOrderService,
    private router: Router,
    private customerService: CustomerService,
    private UserService: UserService,
    private productService: ProductsService,
    private transporterService: TransporterService,
    private vehicleService: VehicleService,
    private factoryService: FactoryService,
    private driverService: DriverService,
    private location: Location,
    private renderer: Renderer2, private el: ElementRef,
    private transactionsInternalService:TransactionsInternalServicesService
  ) {
    
  }

  ngOnInit(): void {
    this.loadingOrderId = Number(this.route.snapshot.paramMap.get('id'));
    this.initForm();
    this.loadLoadingOrderData();

   //Disable the form fields
    Object.keys(this.loadingOrderForm.controls).forEach(key => {
      this.loadingOrderForm.get(key)?.disable();
    });

    //Transporter Data
    this.transporterService.getTransporters().subscribe((response) => {
      this.transporters = response.data;
    });

    this.loadingOrderForm.get('transporterId')?.valueChanges.subscribe(value => {
      
      this.vehicleService.getTransporterVehicles(value).subscribe(response => {
        this.vehicles = response.data;
        
      })
     
    });


    this.driverService.getDrivers().subscribe((response) => {
      this.drivers = response.data;    
    });
  }

 

  initForm() {
    this.loadingOrderForm = this.fb.group({
      factoryId: [''],
      factoryName: [''],
      customerId: [''],
      customerName: [''],
      customerAddressId: [''],
      customerAddressName: [''],
      customerCountry: [''],
      searchCustomer: [''],
      searchProduct: [''],
      searchFactory: [''],
      itemId: [''],
      productName: [''],
      status: [''],
      customerRefNo: [''],
      numberOfRequests: [''],
      transporterId: [''],
      vehicleId: [''],
      driverId: [''],
      quantity: [''],
      transactionDate: [''],
      deliveryNumber: [''],
      
    });
  }

  loadLoadingOrderData() {
    this.loadingOrderService.getById(this.loadingOrderId).subscribe((response) => {
       this.data = response.data;
       console.log("loading order data", this.data);
       this.LoadingOrderStatus = this.data.status;
       this.orderNumber = this.data.orderNumber;
      this.loadingOrderForm.patchValue({
        factoryId: this.data.factoryId,
        factoryName: this.data.factoryName,
        customerId: this.data.customerId,
        customerName: this.data.customerName,
        customerAddressName: this.data.customerAddressName,
        productName: this.data.itemName,
        itemId: this.data.itemId,
        deliveryNumber: this.data.deliveryNumber,
        transporterId: this.data.transporterId,
        customerCountry: this.data.customerCountry,
        customerRefNo: this.data.customerRefNo,
        numberOfRequests: this.data.numberOfRequests,
        vehicleId: this.data.vehicleId,
        quantity: this.data.quantity,
        driverId: this.data.driverId,
        customerAddressId: this.data.customerAddressId,
        status: this.data.status,
        transactionDate:this.data.transactionDate
      });

      const coordinates = this.data.customerAddressLocation;

// Split the string into two parts
      const [latitudeStr, longitudeStr] = coordinates.split(',');

// Convert the parts into numbers
this.latitude = parseFloat(latitudeStr);
this.longitude = parseFloat(longitudeStr);
    });

    
  }

    generatePdf(): void {
      this.transactionsInternalService.generatePdf(this.hiddenReport);
    }
  

  onBack() {
    this.location.back();
  }

}
